var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_wrap _bi"},[_c('h2',{staticClass:"section_title"},[_c('span',{staticClass:"main_title"},[_vm._v(_vm._s(_vm.mainTitle))]),_c('span',{staticClass:"sub_title"},[_vm._v(_vm._s(_vm.subTitle))])]),_c('bible-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }